<template>
  <div id="CarriageContract"  v-loading="loading">
    <div class="buttons"  v-loading="loading">
      <el-button
        type="primary"
        icon="el-icon-plus"
        @click="PrintContractD"
        style="margin: 10px 0"
        >打印 </el-button
      ><el-button
        type="primary"
        icon="el-icon-plus"
        @click="saveContractA"
        style="margin: 10px 10px"
        v-if="dialogForm.approveStatus != 3 && dialogForm.approveStatus != 2"
        >保存
      </el-button>
      <el-button type="primary" @click="setWatermark" style="margin: 10px 0"
        >设置水印
      </el-button>
      <div style="display: inline-flex; width: 300px;margin-left:150px;">
        <el-input v-model="inputPages" placeholder="总页数" style="margin-left: 10px;"></el-input>
        <el-input v-model="inputHeight" placeholder="单页高" style="margin-left: 10px;"></el-input>
        <el-input v-model="inputPosx" placeholder="偏移量" style="margin-left: 10px;"></el-input>
      </div>
    </div>
    <div
      ref="HTMLCarriageContent"
      id="HTMLCarriageContent"
      :key="printClass"
      :class="printClass"
    >
      <div class="carriageContrac1">
        <div style="position: relative">
          <p class="contract_word_p" style="text-align: right; font-size: 14px">
            <span
              style="
                position: absolute;
                z-index: 8;
                left: 10px;
                top: 10px;
                width: 44px;
                height: 57px;
              "
              ><img
                width="44"
                height="57"
                src="../../../assets/images/subContract/LaborContract/logo.png"
                alt="路桥logo" /></span
            ><span style="font-size: 20px; font-family: 宋体; color: red"
              >N</span
            ><span style="font-size: 20px; font-family: 宋体; color: red"
              >O</span
            ><span style="font-size: 20px; font-family: 宋体; color: red"
              >：{{ dialogForm.flowNo || "" }}</span
            >
          </p>
        </div>
        <p class="contract_word_p" style="text-align: right; font-size: 14px">
          <span style="font-size: 20px; font-family: 宋体">&nbsp;</span
          ><span style="font-size: 20px; font-family: 宋体">合同编号：</span>
          <span
            style="
              outline: 0;
              border-bottom: 1px solid rgb(44, 62, 80);
              outline: 0;
              text-indent: 5px;
              display: inline-block;
              min-width: 6cm;
            "
            :contenteditable="
              dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
            "
            class="serialNumber"
            >{{ detailForm.serialNumber }}</span
          >
        </p>
        <p class="contract_word_p" style="text-align: right; font-size: 14px">
          <span
            ><span style="font-size: 20px; font-family: 宋体"
              >&nbsp;</span
            ></span
          >
        </p>
        <p class="contract_word_p" style="text-align: right; font-size: 14px">
          <span
            ><span style="font-size: 20px; font-family: 宋体"
              >&nbsp;</span
            ></span
          >
        </p>
        <p class="contract_word_p" style="text-align: right; font-size: 14px">
          <span
            ><span style="font-size: 20px; font-family: 宋体"
              >&nbsp;</span
            ></span
          >
        </p>
        <p class="contract_word_p" style="text-align: center; font-size: 14px">
          <strong
            ><span
              style="font-size: 56px;font-weight:600;font-family: &#39;锐字云字库小标宋体1.0&#39;;letter-spacing: 2px"
              >运输合同</span
            ></strong
          >
        </p>
        <p class="contract_word_p" style="text-align: justify; font-size: 14px">
          <span style="font-family: 宋体">&nbsp;</span>
        </p>
        <p class="contract_word_p" style="text-align: justify; font-size: 14px">
          <span style="font-family: 宋体">&nbsp;</span>
        </p>
        <p class="contract_word_p" style="text-align: justify; font-size: 14px">
          <span style="font-family: 宋体">&nbsp;</span>
        </p>
        <p class="contract_word_p" style="text-align: justify; font-size: 14px">
          <span style="font-family: 宋体">&nbsp;</span>
        </p>
        <p class="contract_word_p" style="text-align: justify; font-size: 14px">
          <span style="font-family: 宋体">&nbsp;</span>
        </p>
        <p class="contract_word_p" style="text-align: justify; font-size: 14px">
          <span style="font-family: 宋体">&nbsp;</span>
        </p>

        <p
          style="
            font-size: 14px;
            text-align: justify;
            text-indent: 21px;
            line-height: 56px;
          "
        >
          <strong>
            <span style="font-size: 21px; font-family: 宋体; font-weight: 600">
              甲&nbsp;&nbsp;方：
              <span
                style="
                  border-bottom: 1px solid rgb(44, 62, 80);
                  outline: 0;
                  text-indent: 5px;
                  display: inline-block;
                  min-width: 14cm;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                class="partyA"
                >{{ detailForm.partyA ? detailForm.partyA : "" }}</span
              >
            </span>
          </strong>
        </p>
        <p
          style="
            font-size: 14px;
            text-align: justify;
            text-indent: 21px;
            line-height: 56px;
          "
        >
          <strong>
            <span style="font-size: 21px; font-family: 宋体; font-weight: 600">
              乙&nbsp;&nbsp;方：
              <span
                style="
                  border-bottom: 1px solid rgb(44, 62, 80);
                  outline: 0;
                  min-width: 14cm;
                  display: inline-block;
                  text-indent: 5px;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                class="partyB"
                >{{ detailForm.partyB ? detailForm.partyB : "" }}</span
              >
            </span>
          </strong>
        </p>
        <div
          style="
            display: flex;
            font-size: 21px;
            font-family: 宋体;
            font-weight: 600;
            line-height: 70px;
          "
        >
          <div style="text-indent: 21px">项目名称：</div>
          <div style="width: 14.2cm; margin-left: 10px">
            <span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                padding-bottom: 20px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="projectName"
              >{{ detailForm.projectName ? detailForm.projectName : "" }}</span
            >
          </div>
        </div>
        <p
          style="
            font-size: 14px;
            text-align: justify;
            text-indent: 21px;
            line-height: 56px;
          "
        >
          <strong
            ><span style="font-size: 21px; font-family: 宋体; font-weight: 600"
              >签订地点：
              <span
                style="
                  border-bottom: 1px solid rgb(44, 62, 80);
                  outline: 0;
                  min-width: 14cm;
                  display: inline-block;
                  text-indent: 5px;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                class="signPlace"
                >{{ detailForm.signPlace }}</span
              ></span
            ></strong
          >
        </p>
        <p style="font-size: 14px; text-align: justify; text-indent: 21px">
          <span style="font-size: 21px; font-family: 宋体"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
          >
        </p>
        <!--      <p style=";font-size: 14px;text-align: justify"><span style="font-size: 21px;font-family: 宋体">&nbsp;</span></p>-->
        <p
          style="
            font-size: 14px;
            text-align: center;
            text-indent: 21px;
            vertical-align: middle;
          "
        >
          <span
            style="font-size: 21px; font-family: 宋体"
            :contenteditable="
              dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
            "
            class="signDate"
            >{{ detailForm.signDate ? detailForm.signDate : "" }}</span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: center;
            font-size: 14px;
            white-space: normal;
            line-height: 31px;
            page-break-before: always;
          "
        >
          <span>
            <span style="font-size: 24px">
              <span
                style="
                  border-bottom: 1px solid rgb(44, 62, 80);
                  outline: 0;
                  text-indent: 5px;
                  display: inline-block;
                  min-width: 200px;
                  text-align: center;
                  font-weight: 600;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                class="contractName"
                >{{ detailForm.contractName }}</span
              >
            </span>
          </span>
          <span>
            <span style="font-size: 24px; font-family: 黑体l; font-weight: 600">
              运输合同
            </span>
          </span>
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">&nbsp;</span>
        </p>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">
            合同编号：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 400px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="xysContractNum"
              >{{
                detailForm.xysContractNum ? detailForm.xysContractNum : ""
              }}</span
            >
          </span>
        </p>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312"
            >签订时间：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 400px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="signDate1"
              >{{ detailForm.signDate1 ? detailForm.signDate1 : "" }}</span
            >
            <!--          年<span-->
            <!--            style="text-decoration:underline;" :contenteditable="dialogForm.approveStatus != 2&&dialogForm.approveStatus != 3">&nbsp; </span>月<span-->
            <!--            style="text-decoration:underline;" :contenteditable="dialogForm.approveStatus != 2&&dialogForm.approveStatus != 3">&nbsp; </span>日-->
          </span>
        </p>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312"
            >签约地点：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 400px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="signPlace1"
              >{{ detailForm.signPlace1 }}</span
            ></span
          >
        </p>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">
            需 <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>方：
            <span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 400px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              >{{ detailForm.partyA ? detailForm.partyA : ""
              }}<span style="float: right; margin-right: -10px"
                >（甲方）</span
              ></span
            >
          </span>
        </p>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">
            供<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>方：
            <span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 400px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              >{{ detailForm.partyB ? detailForm.partyB : ""
              }}<span style="float: right; margin-right: -10px">（乙方）</span>
            </span>
          </span>
        </p>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312"
            >根据《中华人民共和国民法典》及有关法律法规的规定，遵循平等、自愿和诚实信用的原则，双方就需方<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 4cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="project"
              >{{ detailForm.project }}</span
            >工程<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 4cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="projectTip"
              >{{ detailForm.projectTip }}</span
            >的购销事项协商一致，根据各工程的具体情况，订立以下合同条款：</span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312"
            >一、工作内容</span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312"
            >乙方根据甲方施工需要及要求，将<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 200px;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="materialName"
              >{{ detailForm.materialName }}</span
            >运送至甲方指定的地点。</span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312"
            >二、合同期限：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 400px;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="contractLimit"
              >{{ detailForm.contractLimit }}</span
            >。</span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312"
            >三、综合单价</span
          >
        </p>
        <table
          ref="carriageTable"
          width="100%"
          :key="printClass"
          style="border-collapse: collapse; border-width: 1px"
        >
          <thead style="display: table-header-group">
            <tr style="height: 68px" class="firstRow">
              <td
                width="48"
                style="
                  border-width: 1px;
                  border-color: windowtext;
                  padding: 0px 7px;
                  border-style: solid;
                "
              >
                <p
                  class="contract_word_p"
                  style="text-align: center; font-size: 14px; line-height: 31px"
                >
                  <span style="font-family: 楷体_GB2312">序号</span>
                </p>
              </td>
              <td
                width="200"
                style="
                  border-top-width: 1px;
                  border-top-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                  border-left-width: 0;
                  padding: 0px 7px;
                  border-style: solid;
                  outline: 0;
                "
              >
                <p
                  class="contract_word_p"
                  style="text-align: center; font-size: 14px; line-height: 31px"
                >
                  <span style="font-family: 楷体_GB2312">名称</span>
                </p>
              </td>
              <td
                width="97"
                style="
                  border-top-width: 1px;
                  border-top-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                  border-left-width: 0;
                  padding: 0px 7px;
                  border-style: solid;
                  outline: 0;
                "
              >
                <p
                  class="contract_word_p"
                  style="text-align: center; font-size: 14px; line-height: 31px"
                >
                  <span style="font-family: 楷体_GB2312">运输机械</span>
                </p>
              </td>
              <td
                width="68"
                style="
                  border-top-width: 1px;
                  border-top-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                  border-left-width: 0;
                  padding: 0px 7px;
                  border-style: solid;
                  outline: 0;
                "
              >
                <p
                  class="contract_word_p"
                  style="text-align: center; font-size: 14px; line-height: 31px"
                >
                  <span style="font-family: 楷体_GB2312">单位</span>
                </p>
              </td>
              <td
                width="78"
                style="
                  border-top-width: 1px;
                  border-top-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                  border-left-width: 0;
                  padding: 0px 7px;
                  border-style: solid;
                  outline: 0;
                "
              >
                <p
                  class="contract_word_p"
                  style="text-align: center; font-size: 14px; line-height: 31px"
                >
                  <span style="font-family: 楷体_GB2312">暂定</span>
                </p>
                <p
                  class="contract_word_p"
                  style="text-align: center; font-size: 14px; line-height: 31px"
                >
                  <span style="font-family: 楷体_GB2312">数量</span>
                </p>
              </td>
              <td
                width="77"
                style="
                  border-top-width: 1px;
                  border-top-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                  border-left-width: 0;
                  padding: 0px 7px;
                  border-style: solid;
                  outline: 0;
                "
              >
                <p
                  class="contract_word_p"
                  style="text-align: center; font-size: 14px; line-height: 31px"
                >
                  <span style="font-family: 楷体_GB2312">单价（元）</span>
                </p>
              </td>
              <td
                width="124"
                style="
                  border-top-width: 1px;
                  border-top-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                  border-left-width: 0;
                  padding: 0px 7px;
                  border-style: solid;
                  outline: 0;
                "
              >
                <p
                  class="contract_word_p"
                  style="text-align: center; font-size: 14px; line-height: 31px"
                >
                  <span style="font-family: 楷体_GB2312">暂定合价（元）</span>
                </p>
              </td>
              <td
                width="101"
                style="
                  border-top-width: 1px;
                  border-top-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                  border-left-width: 0;
                  padding: 0px 7px;
                  border-style: solid;
                  outline: 0;
                "
              >
                <p
                  class="contract_word_p"
                  style="text-align: center; font-size: 14px; line-height: 31px"
                >
                  <span style="font-family: 楷体_GB2312">运输要求</span>
                </p>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr
              style="height: 35px; page-break-inside: avoid"
              v-for="item in carriagetableList"
              :key="item.id"
            >
              <td
                width="48"
                style="
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-top-width: 0;
                  padding: 0px 7px;
                  border-style: solid;
                  outline: 0;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column0 }}
              </td>
              <td
                width="127"
                style="
                  border-top-width: 0;
                  border-left-width: 0;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  padding: 0px 7px;
                  border-style: solid;
                  outline: 0;
                "
                :style="
                  item.column1.includes('暂定') ? 'line-height:31px;' : ''
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column1 }}
              </td>
              <td
                width="77"
                style="
                  border-top-width: 0;
                  border-left-width: 0;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  padding: 0px 7px;
                  border-style: solid;
                  outline: 0;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column2 }}
              </td>
              <td
                width="48"
                style="
                  border-top-width: 0;
                  border-left-width: 0;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  padding: 0px 7px;
                  border-style: solid;
                  outline: 0;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column3 }}
              </td>
              <td
                width="58"
                style="
                  border-top-width: 0;
                  border-left-width: 0;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  padding: 0px 7px;
                  border-style: solid;
                  outline: 0;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column4 }}
              </td>
              <td
                width="57"
                style="
                  border-top-width: 0;
                  border-left-width: 0;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  padding: 0px 7px;
                  border-style: solid;
                  outline: 0;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column5 }}
              </td>
              <td
                width="104"
                style="
                  border-top-width: 0;
                  border-left-width: 0;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  padding: 0px 7px;
                  border-style: solid;
                  outline: 0;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column6 }}
              </td>
              <td
                width="81"
                style="
                  border-top-width: 0;
                  border-left-width: 0;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  padding: 0px 7px;
                  border-style: solid;
                  outline: 0;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column7 }}
              </td>
            </tr>
          </tbody>
        </table>
        <div
          style="display: flex"
          v-if="dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3"
        >
          <el-tooltip
            class="item"
            effect="dark"
            content="添加行"
            placement="top-start"
          >
            <i class="el-icon-plus" @click="addItem"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="删除行"
            placement="top-start"
          >
            <i class="el-icon-minus" @click="delItem"></i>
          </el-tooltip>
        </div>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312"
            >此综合单价包括人工费、机械费、水费、电费、协调费、设备维修保养费、管理费、覆盖费、税金和计划利润等,以及与之相关的所用费用，除此之外，甲方不再向乙方支付任何费用。此综合单价在协议期间不得调整。</span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312"
            >三、工程数量的确认</span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 19px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
            font-family: 楷体_GB2312;
          "
        >
          <span>1、</span
          ><span
            style="
              border-bottom: 1px solid rgb(44, 62, 80);
              outline: 0;
              text-indent: 5px;
              word-break: break-all;
              padding-bottom: 2px;
              line-height: 32px;
            "
            :contenteditable="
              dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
            "
            class="addItems1"
            >{{ detailForm.addItems1 || "无" }}</span
          >
        </p>

        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 19px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
            font-family: 楷体_GB2312;
          "
        >
          <span>2、</span
          ><span
            style="
              border-bottom: 1px solid rgb(44, 62, 80);
              outline: 0;
              text-indent: 5px;
              word-break: break-all;
              padding-bottom: 2px;
              line-height: 32px;
            "
            :contenteditable="
              dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
            "
            class="addItems3"
            >{{ detailForm.addItems3 || "无" }}</span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
            font-size: 19px;
            font-family: 楷体_GB2312;
          "
        >
          <span>3、</span
          ><span
            style="
              border-bottom: 1px solid rgb(44, 62, 80);
              outline: 0;
              text-indent: 5px;
              word-break: break-all;
              padding-bottom: 2px;
              line-height: 32px;
            "
            :contenteditable="
              dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
            "
            class="addItems5"
            >{{ detailForm.addItems5 || "无" }}</span
          >
        </p>

        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312"
            >四、结算及付款方式</span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">1</span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >、甲乙双方每月核对数量，以双方共同核定的数量办理结算。</span
          >
        </p>

        <p
          class="contract_word_p"
          style="
            font-size: 19px;
            text-indent: 37px;
            line-height: 31px;
            font-family: 楷体_GB2312；;
          "
        >
          <span> 2、双方本着风险共担，利益共享的原则，一致同意运输价款 </span>
          <span
            style="
              border-bottom: 1px solid rgb(44, 62, 80);
              outline: 0;
              text-indent: 5px;
              word-break: break-all;
              padding-bottom: 2px;
              line-height: 32px;
              font-family: 楷体_GB2312;
            "
            :contenteditable="
              dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
            "
            class="matrailsNeed1"
            >{{
              detailForm.matrailsNeed1
            }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            &nbsp;&nbsp;&nbsp;</span
          >
          <span style="font-size: 19px; font-family: 楷体_GB2312">
            ，以转账支票或电子汇票的方式付款，不以现金方式支付。
          </span>
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">3</span
          ><span style="font-size: 19px; font-family: 楷体_GB2312">、</span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >供方必须指派专人到需方收款,</span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >同时收款前应向甲方出具（符合路桥集团财务审计部要求的）合格的等额发票，否则需方有权拒绝付款直至供方提供合格的等额发票，（税率以供方开具发票时国家规定税率为准，税金随着税率调整而调整）。并供方指派的专人应在第一次收取款项时，必须持与本合同供方单位名称一致的授权收款委托书交需方财务备案；如被授权收款人有变动，则由供方单位重新开具变更授权收款委托书交需方财务备案，否则，需方不予付款。</span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">五</span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >、甲、乙双方的责任与义务：</span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">&nbsp;1</span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >、乙方运输车辆进入施工现场后，必须服从甲方施工管理人员调度与指挥，乙方应遵守甲方施工现场的规章制度。</span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">2</span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >、乙方如发生行车事故（装卸料及运输途中）或其它安全责任事故，其责任和一切经济损失均由乙方承担。如给甲方造成经济损失的，应当承担所有赔偿责任。</span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">3</span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >、乙方车辆必须按指定路线把材料运到指定地点，中途不准变卖、倾倒，根据需要加盖苫布，由乙方负责，甲方不额外增加费用。行车途中车辆发生故障要及时抢修，并报告甲方负责人，因乙方原因造成混合料凝固、报废的，每发生一次乙方应向甲方支付5000元违约金，报废材料按材料单价折算，在运费中扣除，不足部分由乙方据实赔偿。</span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">4</span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >、运输车辆接料时，须服从操作员指挥，并根据生产量适当增减车辆。并保证在限定时间内到达工地。以工地现场负责人签字的过磅单为准。</span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">5</span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >、乙方根据甲方要求及时调度车辆，所有车辆须证照、保险齐全，车况良好，乙方车辆在运料过程中与地方关系的协调（当地居民、交警、城管等）以及所发生的任何费用均由乙方自己负责协调及承担。因车辆原因造成甲方不能准时出料施工，影响甲方生产，造成的相应经济损失由乙方据实赔偿。</span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">6</span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >、乙方车辆进场、退场、住房、各种临时设施及水电等事项由乙方自行解决。</span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">7</span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >、乙方车辆司机必须服从管理，听从指挥，装卸要依次排队，行车中遵守交通规则，严禁酒后开车、超速行驶，做到文明礼貌，优质服务。因乙方车辆司机原因造成第三人人身、财产或其他损失的，由乙方承担全部责任。</span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">8</span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >、在合同期限内，乙方不得以任何理由要求甲方提高运费，凡消极怠工无理取闹的，按违约处理，并扣除所有运输费作为违约金，违约金不足以弥补甲方损失的，乙方还应当据实赔偿。</span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">9</span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >、乙方需做好安全防护工作，司机必须在上岗前进行安全教育或安全交底。</span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">10</span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >、乙方在运输过程中不得超载，必须遵守各项交通法规；对物料按规定进行遮盖，不得撒漏，必须遵守国家及地方政府环境保护相关法律法规，所有费用由乙方自行承担。</span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">11</span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >、乙方应运输过程中，运输车辆经过的沿线村民、商户等个人或群体向甲方或乙方提出赔偿或其他要求，由乙方负责协调处理，产生的一切费用由乙方承担。否则，甲方有权从运输费用中扣除相应费用，不足部分由乙方据实赔偿。</span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312"
            >六、其他约定</span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">1</span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >、甲方现场负责人姓名：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 3.7cm;
                font-family: 楷体_GB2312;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="nameA"
              >{{ detailForm.nameA }}</span
            ></span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 75px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312"
            >职务：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 7cm;
                font-family: 楷体_GB2312;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="workA"
              >{{ detailForm.workA }}</span
            ></span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 50px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312"
            >&nbsp;&nbsp;&nbsp; </span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >身份证号：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 6cm;
                font-family: 楷体_GB2312;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="IDA"
              >{{ detailForm.IDA }}</span
            ></span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 50px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312"
            >&nbsp;&nbsp;&nbsp; </span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >联系方式：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 6cm;
                font-family: 楷体_GB2312;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="contectA"
              >{{ detailForm.contectA }}</span
            ></span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312"
            >&nbsp;&nbsp; </span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >乙方现场负责人姓名：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 4cm;
                font-family: 楷体_GB2312;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="nameB"
              >{{ detailForm.nameB }}</span
            ></span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 75px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312"
            >职务：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 7cm;
                font-family: 楷体_GB2312;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="workB"
              >{{ detailForm.workB }}</span
            ></span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 50px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312"
            >&nbsp;&nbsp;&nbsp; </span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >身份证号：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 6cm;
                font-family: 楷体_GB2312;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="IDB"
              >{{ detailForm.IDB }}</span
            ></span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 50px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312"
            >&nbsp;&nbsp;&nbsp; </span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >联系方式：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 6cm;
                font-family: 楷体_GB2312;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="contectB"
              >{{ detailForm.contectB }}</span
            ></span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">2</span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >、若本协议发生争议,双方应协商解决，协商不成，任何一方均有权向甲方所在地人民法院提起诉讼。</span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312"
            >违约方应当承担守约方为解决争议而支付的所有费用，包括但不限于诉讼费、律师费、评估费、鉴定费、审计费、差旅费等。</span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">3</span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >、未尽事宜,经双方协商一致可另行补充约定，补充合同与本合同具有同等法律效力。</span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">4</span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >、本协议自甲乙双方法定代表人或委托代理人签字并加盖公章之日起生效。协议有效期以甲方工程项目的需要为标准，乙方不得以任何理由单方面中止协议。</span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">5</span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >、本协议一式四份,甲方三份,乙方一份,具有同等法律效力。</span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312"
            >特别条款:</span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312"
            >乙方每次收取运输款时，需出具合法的等额发票给甲方，否则，甲方不予付款或追回已付款。如乙方提供给甲方的发票被税务部门查证为假发票，乙方除承担行政罚款、民事责任、刑事犯罪等一切责任外，还须向甲方支付不低于涉案发票金额20%的违约金，同时向甲方重新提供税务部门出具的合法发票。</span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">&nbsp;</span>
        </p>
        <table width="100%" style="border-collapse: collapse">
          <tbody>
            <tr
              style="height: 100px; page-break-inside: avoid"
              class="firstRow"
            >
              <td
                width="284"
                style="
                  border-width: 1px;
                  border-color: windowtext;
                  padding: 2px 7px;
                  border-style: solid;
                "
              >
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >供 方：（公 章）：</span
                  ><span
                    style="font-size: 19px"
                    class="partA_gongzhang"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partA_gongzhang }}</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >授权委托人（签字）：</span
                  ><span
                    style="font-size: 19px"
                    class="partA_sign"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partA_sign }}</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 19px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px">电话：</span>
                  <span
                    class="partA_phone"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partA_phone }}</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >账户信息：</span
                  ><span
                    style="font-size: 19px"
                    class="partA_account"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partA_account }}</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >&nbsp;</span
                  ><span style="text-decoration: underline"></span>
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >通信地址：</span
                  ><span
                    style="font-size: 19px"
                    class="partA_ads"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partA_ads }}</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >传真：</span
                  ><span
                    style="font-size: 19px"
                    class="partA_fix"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partA_fix }}</span
                  >
                </p>
              </td>
              <td
                width="285"
                style="
                  border-top-width: 1px;
                  border-top-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                  border-left: 0;
                  padding: 2px 7px;
                  border-style: solid;
                "
              >
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >需 方（公 章）：</span
                  ><span
                    style="font-size: 19px"
                    class="partB_gongzhang"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partB_gongzhang }}</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >授权委托人（签字）：</span
                  ><span
                    style="font-size: 19px"
                    class="partB_sign"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partB_sign }}</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 19px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px">电话：</span>
                  <span
                    class="partB_phone"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partB_phone }}</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >&nbsp;</span
                  ><span style="text-decoration: underline"></span>
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >&nbsp;</span
                  ><span style="font-size: 19px"></span>
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >通讯地址：</span
                  ><span
                    style="font-size: 19px"
                    class="partB_ads"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partB_ads }}</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >传真：</span
                  ><span
                    style="font-size: 19px"
                    class="partB_fix"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partB_fix }}</span
                  >
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <p
          class="contract_word_p"
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312"
            >附件:供方的营业执照、机构代码证复印件</span
          >
        </p>
        <p
          class="contract_word_p"
          style="text-align: justify; font-size: 14px; white-space: normal"
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >供方法定代表人身份证复印件</span
          >
        </p>
        <p class="contract_word_p"><br /></p>
      </div>
    </div>
    <div class="printWrap" v-show="false">
      <div
        v-html="carriageContent"
        class="mainHtml"
        id="printCarriageContent"
      ></div>
    </div>

    <setWatermarkDialog
      ref="setWatermarking"
      @setWaterMarkFun="setWaterMarkFun"
    ></setWatermarkDialog>
  </div>
</template>

<script>
import {
  getServiceContractDetailService, //获取合同填充内容
} from "@/services/allContractServices";
import printJS from "print-js";
import { mixins } from "@/page/contract/template/mixin.js";
import setWatermarkDialog from "../commonCell/setWatermarkDialog.vue";
import { addPageNum, getTableData } from "./common.js";
import { addPageNumCustom } from "./common.js";

export default {
  name: "CarriageContract",
  components: {
    setWatermarkDialog,
  },
  mixins: [mixins],
  data() {
    return {
      printClass: "",
      carriageContent: "", //富文本编辑器内容
      watermark: [""],
      saveflag: false,
      detailForm: { ...this.dialogForm },
      carriagetableList: [
        {
          id: 1,
          column0: "",
          column1: "",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
          column7: "",
        },
        {
          id: 2,
          column0: "",
          column1: "",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
          column7: "",
        },
        {
          id: 3,
          column0: "",
          column1: "",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
          column7: "",
        },
        {
          id: 4,
          column0: "",
          column1: "",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
          column7: "",
        },
        {
          id: 5,
          column0: "",
          column1: "",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
          column7: "",
        },
        {
          id: 6,
          column0: "",
          column1: "",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
          column7: "",
        },
        {
          id: 2000,
          column0: "",
          column1: "合计（暂定）",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
          column7: "",
        },
        {
          id: 2001,
          column0: "",
          column1: "含税总价：大写（暂定）（不含税价：      税率：    税金：）",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
          column7: "",
        },
      ], //中间表格数据
      inputPages: "",
      inputHeight: 1010,
      inputPosx: 37,
    };
  },
  methods: {
    addItem() {
      let len = this.carriagetableList.length - 3;
      let id = (this.carriagetableList[len]?.id ?? 0) + 1;
      let item = {
        id: id,
        column0: "",
        column1: "",
        column2: "",
        column3: "",
        column4: "",
        column5: "",
        column6: "",
        column7: "",
      };
      this.carriagetableList.splice(len + 1, 0, item);
    },
    delItem() {
      if (this.carriagetableList.length > 2) {
        // const table = this.$refs.carriageTable;
        // this.carriagetableList = getTableData(table, this.carriagetableList, 8);
        this.carriagetableList.splice(this.carriagetableList.length - 3, 1);
      }
    },
    //获取一条劳务合同信息
    getsubServiceContractDetail(id) {
      if (!id) return;
      let param = {};
      param.id = id;
      getServiceContractDetailService(param)
        .then((res) => {
          if (res.code == 10000000) {
            let data = {};
            if (res.data.subContractPrintVO) {
              data = res.data.subContractPrintVO;
              this.watermark = res.data.subContractPrintVO.watermark || [""];
              if (data.content) {
                this.saveflag = true;
                this.detailForm = JSON.parse(data.content);
                if (this.detailForm.carriagetableList) {
                  this.carriagetableList = JSON.parse(
                    this.detailForm.carriagetableList
                  );
                  this.carriagetableList.forEach((item, index) => {
                    if (index == this.carriagetableList.length - 2) {
                      item.id = 2000;
                    } else if (index == this.carriagetableList.length - 1) {
                      item.id = 2001;
                    } else {
                      item.id = index + 1;
                    }
                    return item;
                  });
                }
              } else {
                this.detailForm = { ...this.dialogForm };
                this.carriagetableList = [
                  {
                    id: 1,
                    column0: "",
                    column1: "",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                    column7: "",
                  },
                  {
                    id: 2,
                    column0: "",
                    column1: "",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                    column7: "",
                  },
                  {
                    id: 3,
                    column0: "",
                    column1: "",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                    column7: "",
                  },
                  {
                    id: 4,
                    column0: "",
                    column1: "",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                    column7: "",
                  },
                  {
                    id: 5,
                    column0: "",
                    column1: "",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                    column7: "",
                  },
                  {
                    id: 6,
                    column0: "",
                    column1: "",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                    column7: "",
                  },
                  {
                    id: 2000,
                    column0: "",
                    column1: "合计（暂定）",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                    column7: "",
                  },
                  {
                    id: 2001,
                    column0: "",
                    column1:
                      "含税总价：大写（暂定）（不含税价：      税率：    税金：）",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                    column7: "",
                  },
                ]; //中间表格数据
              }
            }
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
          this.loading=false;
        })
        .catch((error) => {
          this.$alert(error, "提示", {
            confirmButtonText: "确定",
          });
          this.loading=false;
        });
    },
    saveContractA() {
      if (this.detailForm.approveStatus == 2) {
        this.$alert("合同为待审核无法修改", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      // this.getValues();
      const table = this.$refs.carriageTable;
      this.carriagetableList = getTableData(table, this.carriagetableList, 8);
      this.detailForm.carriagetableList = JSON.stringify(
        this.carriagetableList
      );
      // this.tableKey = Math.random();
      this.saveCommon('carriageContract');
    },
    getValues() {
      // let Id = document.getElementById("HTMLCarriageContent");
      let Id = document.getElementsByClassName(this.printClass)[0];
      this.detailForm.serialNumber =
        Id.getElementsByClassName("serialNumber")[0].innerText.trim();
      this.detailForm.partyA =
        Id.getElementsByClassName("partyA")[0].innerText.trim();
      this.detailForm.partyB =
        Id.getElementsByClassName("partyB")[0].innerText.trim();
      this.detailForm.projectName =
        Id.getElementsByClassName("projectName")[0].innerText.trim();
      this.detailForm.signPlace =
        Id.getElementsByClassName("signPlace")[0].innerText.trim();
      Id.getElementsByClassName("signPlace")[0].innerHTML =
        this.detailForm.signPlace;
      this.detailForm.signPlace1 =
        Id.getElementsByClassName("signPlace1")[0].innerText.trim();
      Id.getElementsByClassName("signPlace1")[0].innerHTML =
        this.detailForm.signPlace1;
      this.detailForm.signDate1 =
        Id.getElementsByClassName("signDate1")[0].innerText.trim();
      Id.getElementsByClassName("signDate1")[0].innerHTML =
        this.detailForm.signDate1;

      this.detailForm.signDate =
        Id.getElementsByClassName("signDate")[0].innerText;
      Id.getElementsByClassName("signDate")[0].innerHTML =
        this.detailForm.signDate;

      this.detailForm.xysContractNum =
        Id.getElementsByClassName("xysContractNum")[0].innerText.trim();
      Id.getElementsByClassName("xysContractNum")[0].innerHTML =
        this.detailForm.xysContractNum;

      this.detailForm.contractName =
        Id.getElementsByClassName("contractName")[0].innerText.trim(); //合同名称

      Id.getElementsByClassName("contractName")[0].innerHTML =
        this.detailForm.contractName;

      this.detailForm.project =
        Id.getElementsByClassName("project")[0].innerText.trim(); //发包人
      this.detailForm.projectTip =
        Id.getElementsByClassName("projectTip")[0].innerText.trim(); //施工总承包协议

      this.detailForm.materialName =
        Id.getElementsByClassName("materialName")[0].innerText.trim(); //结算方式
      this.detailForm.contractLimit =
        Id.getElementsByClassName("contractLimit")[0].innerText.trim(); //合同期限

      this.detailForm.addItems1 =
        Id.getElementsByClassName("addItems1")[0].innerText; //1.1
      this.detailForm.addItems3 =
        Id.getElementsByClassName("addItems3")[0].innerText; //1.2
      this.detailForm.addItems5 =
        Id.getElementsByClassName("addItems5")[0].innerText; //1.3

      this.detailForm.matrailsNeed1 =
        Id.getElementsByClassName("matrailsNeed1")[0].innerText;
      //其他约定
      this.detailForm.nameA =
        Id.getElementsByClassName("nameA")[0].innerText.trim(); //甲方现场负责人姓名
      this.detailForm.workA =
        Id.getElementsByClassName("workA")[0].innerText.trim(); //职务
      this.detailForm.IDA =
        Id.getElementsByClassName("IDA")[0].innerText.trim(); //身份证号
      this.detailForm.contectA =
        Id.getElementsByClassName("contectA")[0].innerText.trim(); //联系方式电话
      // this.detailForm.fk6 = Id.getElementsByClassName("fk6").innerText.trim(); //合同订立地点
      this.detailForm.nameB =
        Id.getElementsByClassName("nameB")[0].innerText.trim(); //合同订立地点
      this.detailForm.workB =
        Id.getElementsByClassName("workB")[0].innerText.trim(); //合同订立地点
      this.detailForm.IDB =
        Id.getElementsByClassName("IDB")[0].innerText.trim(); //合同订立地点
      this.detailForm.contectB =
        Id.getElementsByClassName("contectB")[0].innerText.trim(); //合同订立地点
      Id.getElementsByClassName("project")[0].innerHTML =
        this.detailForm.project;
      Id.getElementsByClassName("projectTip")[0].innerHTML =
        this.detailForm.projectTip;
      Id.getElementsByClassName("materialName")[0].innerHTML =
        this.detailForm.materialName;
      Id.getElementsByClassName("contractLimit")[0].innerHTML =
        this.detailForm.contractLimit;
      Id.getElementsByClassName("addItems1")[0].innerHTML =
        this.detailForm.addItems1;

      Id.getElementsByClassName("addItems3")[0].innerHTML =
        this.detailForm.addItems3;

      Id.getElementsByClassName("addItems5")[0].innerHTML =
        this.detailForm.addItems5;

      Id.getElementsByClassName("matrailsNeed1")[0].innerHTML =
        this.detailForm.matrailsNeed1;
      Id.getElementsByClassName("nameA")[0].innerHTML = this.detailForm.nameA;
      Id.getElementsByClassName("workA")[0].innerHTML = this.detailForm.workA;
      Id.getElementsByClassName("IDA")[0].innerHTML = this.detailForm.IDA;
      Id.getElementsByClassName("contectA")[0].innerHTML =
        this.detailForm.contectA;
      Id.getElementsByClassName("nameB")[0].innerHTML = this.detailForm.nameB;
      Id.getElementsByClassName("workB")[0].innerHTML = this.detailForm.workB;
      Id.getElementsByClassName("IDB")[0].innerHTML = this.detailForm.IDB;
      Id.getElementsByClassName("contectB")[0].innerHTML =
        this.detailForm.contectB;

      this.detailForm.partA_gongzhang =
        Id.getElementsByClassName("partA_gongzhang")[0].innerText;
      Id.getElementsByClassName("partA_gongzhang")[0].innerHTML =
        this.detailForm.partA_gongzhang;
      this.detailForm.partA_sign =
        Id.getElementsByClassName("partA_sign")[0].innerText;
      Id.getElementsByClassName("partA_sign")[0].innerHTML =
        this.detailForm.partA_sign;
      this.detailForm.partA_phone =
        Id.getElementsByClassName("partA_phone")[0].innerText;
      Id.getElementsByClassName("partA_phone")[0].innerHTML =
        this.detailForm.partA_phone;
      this.detailForm.partA_account =
        Id.getElementsByClassName("partA_account")[0].innerText;
      Id.getElementsByClassName("partA_account")[0].innerHTML =
        this.detailForm.partA_account;
      this.detailForm.partA_ads =
        Id.getElementsByClassName("partA_ads")[0].innerText;
      Id.getElementsByClassName("partA_ads")[0].innerHTML =
        this.detailForm.partA_ads;
      this.detailForm.partA_fix =
        Id.getElementsByClassName("partA_fix")[0].innerText;
      Id.getElementsByClassName("partA_fix")[0].innerHTML =
        this.detailForm.partA_fix;

      this.detailForm.partB_gongzhang =
        Id.getElementsByClassName("partB_gongzhang")[0].innerText;
      Id.getElementsByClassName("partB_gongzhang")[0].innerHTML =
        this.detailForm.partB_gongzhang;
      this.detailForm.partB_sign =
        Id.getElementsByClassName("partB_sign")[0].innerText;
      Id.getElementsByClassName("partB_sign")[0].innerHTML =
        this.detailForm.partB_sign;
      this.detailForm.partB_phone =
        Id.getElementsByClassName("partB_phone")[0].innerText;
      Id.getElementsByClassName("partB_phone")[0].innerHTML =
        this.detailForm.partB_phone;
      this.detailForm.partB_ads =
        Id.getElementsByClassName("partB_ads")[0].innerText;
      Id.getElementsByClassName("partB_ads")[0].innerHTML =
        this.detailForm.partB_ads;

      this.detailForm.partB_fix =
        Id.getElementsByClassName("partB_fix")[0].innerText;
      Id.getElementsByClassName("partB_fix")[0].innerHTML =
        this.detailForm.partB_fix;
    },
   
    //打印当前合同
    PrintContractD() {
      if (this.dialogForm.approveStatus != 3) {
        this.$alert("合同尚未通过审核，无法打印", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      // let Id = document.getElementById("HTMLCarriageContent");
      let Id = document.getElementsByClassName(this.printClass)[0];
      let elementsToRemove = Id.querySelectorAll(".page-num");
      elementsToRemove.forEach(function (element) {
        element.parentNode.removeChild(element);
      });
      //addPageNum(Id, 1, "carriageContract");
      addPageNumCustom(Id, 1, "carriageContract", parseFloat(this.inputPages)+1, this.inputHeight, this.inputPosx);
      
      this.$set(
        this,
        "carriageContent",
        this.$refs.HTMLCarriageContent.innerHTML
      );
      this.$nextTick(() => {
        printJS({
          printable: "printCarriageContent",
          type: "html",
          targetStyles: ["*"],
          ignoreElements: ["no-print", "bc", "gb"],
          scanStyles: false,
          style: `@page { size: auto;margin:10mm  }  p{line-height:31px;} .carriageContrac1 {background: url("data:image/svg+xml,%3Csvg width='200' height='200' xmlns='http://www.w3.org/2000/svg'%3E%3Ctext x='50%25' y='50%25' font-size='14' fill-opacity='0.3' text-anchor='middle' dominant-baseline='middle' transform='rotate(-35, 100 100)'%3E${this.watermark.join(
            ";"
          )}%3C/text%3E%3C/svg%3E");
}`,
        });
      });
    },
    //设置水印
    setWatermark() {
      this.$refs.setWatermarking.showwaterMarkDialog(
        this.subServiceContractId,
        this.watermark
      );
    },
    setWaterMarkFun(val) {
      this.watermark = val;
      let param = {
        warterMark: this.watermark,
        version: "1.0",
        flag: 2,
      };
      this.$emit("savePrintInfo", param);
    },
  },
};
</script>

<style>
.page-num {
  display: none;
}
#HTMLCarriageContent {
  /* position: relative; */
  width: 20cm;
  padding: 0 10px;
  margin-top: 58px;
  box-shadow: 0px 4px 12px 2px #bbb;
}
p {
  line-height: 31px;
}

.buttons {
  width: 22cm;
  height: 56px;
  position: fixed;
  top: 90px;
  background: white;
  z-index: 9;
}

.printWrap {
  width: 21cm;
  margin: 30px auto;
  padding: 5mm;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
}

.mainHtml {
  width: 21cm;
}
</style>
